import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from 'clsx';
/**
 * Divider component for auth forms
 * Typically used to separate OAuth buttons from email/password form
 */
export const AuthDivider = ({ className, children = 'or' }) => {
    return (_jsxs("div", { className: clsx('auth-divider', className), children: [_jsx("div", { className: "auth-divider-line" }), _jsx("span", { className: "auth-divider-text", children: children }), _jsx("div", { className: "auth-divider-line" })] }));
};
AuthDivider.displayName = 'AuthDivider';
//# sourceMappingURL=AuthDivider.js.map